<template>
  <v-app-bar-nav-icon
    aria-label="Navigation"
    color="primary"
    class="icon"
    @click.stop="drawerOpen = !drawerOpen"
  />
  <div v-show="mounted">  
    <v-navigation-drawer
      v-model="drawerOpen"
      location="end"
      color="dim"
      :class="['px-5 pt-4', { 'drawer-open': drawerOpen }]"
      temporary
    >
      <CloseBtn icon-color="#fff" class="close icon" @click="drawerOpen = false" />
      <NavBarMobileLogo />
      <div class="pt-5">
        <v-expansion-panels v-model="openPanelIndex" bg-color="dim" flat>
          <NavBarMobilePanel :header="$tt('footer.explore')">
            <PageLinksList class="gap-5" />
          </NavBarMobilePanel>
          
          <NavBarMobilePanel :header="$tt('nav.visa_country_select.label')">
            <VisaCountryLinkList source="nav" />
          </NavBarMobilePanel>

          <NavBarMobilePanel :header="$tt('footer.contact')" class="contact">
            <div class="flex col gap-3">
              <WhatsappLink>
                <AppBtn prepend-icon="mdi:whatsapp" block white>
                  {{ $tt('whatsapp') }}
                </AppBtn>
              </WhatsappLink>
              <a v-if="telegram" :href="telegram" target="_blank">
                <AppBtn prepend-icon="uil:telegram-alt" block white>
                  {{ $tt('socials.telegram') }}
                </AppBtn>
              </a>
              <PhoneLink>
                <AppBtn prepend-icon="uil:phone" block white>
                  {{ phone.display }}
                </AppBtn>
              </PhoneLink>
              <SupportEmailLink>
                <AppBtn prepend-icon="clarity:email-line" block white>
                  {{ supportEmail }}
                </AppBtn>
              </SupportEmailLink>
              <AppBtn prepend-icon="bx:chat" block white @click="openChatboxBus.emit">
                {{ $tt('chat') }}
              </AppBtn>
              <AppLink to="/contact">
                <AppBtn prepend-icon="bx:support" block white>
                  {{ $tt('support') }}
                </AppBtn>
              </AppLink>
            </div>
            <div class="mt-7 mb-4">
              <h4 class="mb-5">{{ $tt('follow_us') }}</h4>
              <SocialLinks size="large" />
            </div>
          </NavBarMobilePanel>
        </v-expansion-panels>

        <div class="flex col gap-5 mt-6 mb-5">
          <LocaleSelect />
          <PaymentLogos />
          <div class="flex gap-4 items-end">
            <p>
              {{ companyAddressText }}
              <br>
              © {{ getCurrentYear() }} {{ $tt('brand.name') }}
            </p>
          </div>
        </div>
      </div>
    </v-navigation-drawer>
  </div>
</template>

<script setup lang="ts">
import { useMounted } from '@vueuse/core';
import { getCurrentYear } from '~/helpers/date';

const { phone, supportEmail, telegram, companyAddressText } = useCommunication();
const { openChatboxBus } = useEmitter();

const drawerOpen = ref(false);
const mounted = useMounted();
const openPanelIndex = ref([0, 2]);
</script>

<style lang="scss" scoped>
.drawer-open {
  width: 100vw !important;
}
a, :deep(a), p, span, h4, :deep(h4) {
  color: white;
}
.icon {
  font-size: 24px;
}
.close {
  position: absolute;
  top: var(--space-2);
  inset-inline-end: var(--space-4);
}
h4, .address-info {
  line-height: var(--lh-md);
}
.contact {
  border-bottom: 1px solid #fff;
}
:deep(.v-expansion-panel--active) {
  margin-top: 0 !important;
}
</style>